import { CustomHomePageSearchBar } from '@internal/backstage-plugin-custom-search-ui-extension';
import { Grid, makeStyles } from '@material-ui/core';

import { triggerDynatraceEvent } from '../../../utils/trigger-dynatrace-events';

const useStyles = makeStyles(theme => ({
  searchBar: {
    display: 'flex',
    maxWidth: '55vw',
    backgroundColor: theme.palette.background.paper,
    padding: '0px 0px',
    margin: 'auto',
    fontWeight: 300,
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      maxWidth: '85vw',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '95vw',
    },
    '& input': {
      fontSize: '18px',
      fontFamily: 'FS Elliot Pro',
    },
    '& input:-webkit-autofill': {
      '-webkit-box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      'box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      '-webkit-text-fill-color': `${theme.palette.text.primary} !important`,
      fontSize: '18px !important',
      fontFamily: 'FS Elliot Pro !important',
    },
    '& input:-webkit-autofill:hover': {
      '-webkit-box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      'box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      '-webkit-text-fill-color': `${theme.palette.text.primary} !important`,
      fontSize: '18px !important',
      fontFamily: 'FS Elliot Pro !important',
    },
    '& input:-webkit-autofill:focus': {
      '-webkit-box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      'box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      '-webkit-text-fill-color': `${theme.palette.text.primary} !important`,
      fontSize: '18px !important',
      fontFamily: 'FS Elliot Pro !important',
    },
    '& input:-webkit-autofill:active': {
      '-webkit-box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      'box-shadow': `0 0 0 1000px ${theme.palette.background.paper} inset !important`,
      '-webkit-text-fill-color': `${theme.palette.text.primary} !important`,
      fontSize: '18px !important',
      fontFamily: 'FS Elliot Pro !important',
    },
  },
  searchGrid: {
    // @ts-expect-error custom color
    backgroundColor: theme.palette.search.background,
    padding: '15px 0px 10px 0px',
  },
}));
const handleSearchEvent = () => {
  const eventType: any = {
    search_page_type: {
      value: 'HomeSearchModal',
      public: true,
    },
  };
  triggerDynatraceEvent(eventType, 'search_page_event');
};

export const SearchBar = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={10}
      classes={{
        root: classes.searchGrid,
      }}
    >
      <CustomHomePageSearchBar
        classes={{ root: classes.searchBar }}
        placeholder="Search for specific phrases by wrapping them in double quotes."
        onClick={handleSearchEvent}
      />
    </Grid>
  );
};
